import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'relativeTime',
    standalone: true
})
export class RelativeTimePipe implements PipeTransform {
    isMobile: boolean = window.innerWidth <= 1000;

    transform(value: string | number | Date): string {
        if (!value) return '';

        const dateTime = new Date(value);
        const now = new Date();
        const diff: number = dateTime.getTime() - now.getTime(); // Changed to `date - now` to handle future dates
        const seconds: number = Math.floor(Math.abs(diff) / 1000);
        const minutes: number = Math.floor(seconds / 60);
        const hours: number = Math.floor(minutes / 60);
        const days: number = Math.floor(hours / 24);
        const weeks: number = Math.floor(days / 7);
        const months: number = Math.floor(days / 30);
        const years: number = Math.floor(months / 12);

        let date: string = ''
        if (years > 0) {
            date = date + `${years}` + (this.isMobile ? 'y' : ` year${years !== 1 ? 's' : ''}`)
        } else if (months > 0) {
            date = date + `${months}` + (this.isMobile ? 'mo' : ` month${months !== 1 ? 's' : ''}`)
        } else if (weeks > 0) {
            date = date + `${weeks}` + (this.isMobile ? 'w' : ` week${weeks !== 1 ? 's' : ''}`)
        } else if (days > 0) {
            date = date + `${days}` + (this.isMobile ? 'd' : ` day${days !== 1 ? 's' : ''}`)
        } else if (hours > 0) {
            date = date + `${hours}` + (this.isMobile ? 'h' : ` hour${hours !== 1 ? 's' : ''}`)
        } else if (minutes > 0) {
            date = date + `${minutes}` + (this.isMobile ? 'm' : ` minute${minutes !== 1 ? 's' : ''}`)
        } else {
            date = date + `${seconds}` + (this.isMobile ? 's' : ` second${seconds !== 1 ? 's' : ''}`)
        }

        if (diff > 0) {
            date = 'in ' + date;
        } else {
            date = date + ' ago';
        }
        return date
    }
}
